module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou6-dfdda9d419a5d6381bd8415de97e92f8.jpg";